var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "property-base",
    { attrs: { label: _vm.resource("JourneyBuilder_FilterSettings_Delay") } },
    [
      _c("time-period", {
        model: {
          value: _vm.newValue,
          callback: function($$v) {
            _vm.newValue = $$v
          },
          expression: "newValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }